import React from "react";

const OrangeDivider = () => {
  return <div className="start__orange-divider" data-test="divider" />;
};

export default OrangeDivider;
